import { create } from "zustand";

export interface DistanceHistoryEntry {
  id: string;
  planId: string;
  planLabel: string;
  from: string;
  to: string;
  metric: string;
  distance: number;
  unit: string;
  at: number;
}

interface DistanceQueryState {
  isOpen: boolean;
  history: DistanceHistoryEntry[];
  toggleOpen: () => void;
  setOpen: (open: boolean) => void;
  addHistory: (entry: DistanceHistoryEntry) => void;
  clearHistory: () => void;
}

const LS_KEY = "distanceQueryHistory";
const MAX_HISTORY = 50;

const loadHistory = (): DistanceHistoryEntry[] => {
  try {
    const raw = localStorage.getItem(LS_KEY);
    return raw ? (JSON.parse(raw) as DistanceHistoryEntry[]) : [];
  } catch {
    return [];
  }
};

const saveHistory = (history: DistanceHistoryEntry[]) => {
  try {
    localStorage.setItem(LS_KEY, JSON.stringify(history.slice(0, MAX_HISTORY)));
  } catch {
    /* ignore quota / serialization errors */
  }
};

export const useDistanceQueryStore = create<DistanceQueryState>((set) => ({
  isOpen: false,
  history: loadHistory(),
  toggleOpen: () => set((state) => ({ isOpen: !state.isOpen })),
  setOpen: (open: boolean) => set({ isOpen: open }),
  addHistory: (entry: DistanceHistoryEntry) =>
    set((state) => {
      const history = [entry, ...state.history].slice(0, MAX_HISTORY);
      saveHistory(history);
      return { history };
    }),
  clearHistory: () => {
    saveHistory([]);
    set({ history: [] });
  },
}));
